import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-flower-line text-xl text-primary-400"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                初音岛
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors">使用条款</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">关注我们</h4>
            <div className="flex gap-3 mb-4">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href={siteInfo.socialLinks.bilibili} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
            <p className="text-sm text-background-500">
              {siteInfo.email}
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <p className="text-sm text-background-600">
            本站为粉丝自建资讯平台，与CIRCUS官方无关
          </p>
        </div>
      </div>
    </footer>
  );
}